import React from 'react';
import { StarIcon } from 'lucide-react';
type RatingStarsProps = {
  value: number;
  size?: number;
  className?: string;
  /** Hide from screen readers when an adjacent text already states the rating. */
  decorative?: boolean;
};

/** Read-only stars with partial fill (e.g. 4.6 → 4 full + 60%). */
export function RatingStars({
  value,
  size = 18,
  className = '',
  decorative = false
}: RatingStarsProps) {
  return <span className={`inline-flex items-center gap-0.5 ${className}`} role={decorative ? undefined : 'img'} aria-hidden={decorative || undefined} aria-label={decorative ? undefined : `${value} out of 5 stars`} data-id="element-659" data-mp="sffqpqxi7wzn">
      {[0, 1, 2, 3, 4].map(i => {
      const fill = Math.max(0, Math.min(1, value - i));
      return <span key={i} className="relative inline-block" style={{
        width: size,
        height: size
      }} data-id="element-660" data-mp="1c4q8rbkq2u0x">
            <StarIcon className="absolute inset-0 text-titanium/35" style={{
          width: size,
          height: size
        }} strokeWidth={1.5} data-id="element-661" data-mp="17e027v0k8l4n" />
            <span className="absolute inset-y-0 left-0 overflow-hidden" style={{
          width: `${fill * 100}%`
        }} data-id="element-662" data-mp="33578pbcxsllx">
              <StarIcon className="fill-[#FFC94D] text-[#FFC94D]" style={{
            width: size,
            height: size
          }} strokeWidth={1.5} data-id="element-663" data-mp="383ii5kzbku3m" />
            </span>
          </span>;
    })}
    </span>;
}